var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          staticClass: "card-info",
          attrs: { "body-style": { width: "100%" }, shadow: "hover" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("Número do processo:")]),
                _vm._v(_vm._s(" " + _vm.processo.numero))
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("Tipo de processo:")]),
                _vm._v(_vm._s(" " + _vm.processo.tipoCadastro.nome))
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("Nome/Razão social:")]),
                _vm._v(_vm._s(" " + _vm.processo.nomeRazaoSocialInteressado))
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin-top-20", attrs: { gutter: 40 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("CPF/CNPJ:")]),
                _vm._v(_vm._s(" " + _vm.processo.cpfCnpjInteressado))
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("Telefone:")]),
                _vm._v(_vm._s(" " + _vm.processo.telefone.replace(/,/g, ", ")))
              ]),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("b", [_vm._v("E-mail:")]),
                _vm._v(_vm._s(" " + _vm.processo.email.replace(/,/g, ", ")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78745762", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78745762","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/financeiro/processoFisico/VisualizarProcessoFisico.vue
// module id = null
// module chunks = 